import { NAV_HUB_CARD_IMAGES } from '@/pages/ipe/workbench/constants/navHubCardImages';

/** null = 回落到会话上限 500（见 uploadSessionLimits / studioSourceLimit） */
export const IMAGE_CROP_MAX_SOURCES = null;

/** Studio 选图/上传达上限时的提示文案（有上限时使用） */
export const IMAGE_CROP_BATCH_LIMIT_TOAST = '单批次图片数量已达上限';

/** Qwen 每批上限 */
export const IMAGE_CROP_QWEN_BATCH_SIZE = 5;

/**
 * Worker 批任务 mode（T2 后端 mode=auto 不走 Qwen；前端固定 qwen 规避）。
 */
export const IMAGE_CROP_WORKER_MODE = 'qwen';

/** workbench navId */
export const IMAGE_CROP_NAV_ID = 'imageCrop';

/** 轮询间隔 */
export const IMAGE_CROP_POLL_INTERVAL_MS = 2000;

export function getImageCropStudioConfig() {
  const images = NAV_HUB_CARD_IMAGES.imageCrop;
  return {
    title: '图案裁剪',
    subtitle: '智能识别 T 恤印花区域，自动裁剪图案',
    hero: {
      image: images?.result,
      caption: '自动识别印花图案，快速裁剪出可用素材',
    },
    tryExamples: [
      { id: 'demo-1', thumb: images?.source, sampleUrl: images?.source },
      { id: 'demo-2', thumb: images?.result, sampleUrl: images?.source },
    ],
    historyEmptyDescription: '图案裁剪完成后，记录将自动保存在这里',
  };
}
